exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*base-link-mixin*/\n.ota-btn-main {\n  margin: 0;\n  width: 160px; }\n  @media screen and (max-width: 768px) {\n    .ota-btn-main {\n      font-size: 16px;\n      background-color: unset;\n      color: #003a90;\n      line-height: unset;\n      height: unset; }\n      .ota-btn-main:hover, .ota-btn-main.touch {\n        background-color: unset; } }\n\np {\n  margin-bottom: 30px; }\n\n.title-text {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20px;\n  margin-bottom: 10px; }\n  @media screen and (max-width: 768px) {\n    .title-text {\n      font-size: 16px; } }\n\nimg {\n  height: 60px; }\n\n.box-success {\n  margin: 30px 0 10px 0 !important; }\n\n.action-button {\n  padding: 15px;\n  border-top: 1px solid #DFE1E6;\n  padding-top: 15px;\n  text-align: right;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.box-content {\n  padding-left: 30px;\n  padding-right: 30px; }\n  @media screen and (max-width: 768px) {\n    .box-content {\n      padding-left: 15px;\n      padding-right: 15px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-general-message/dialog-general-message.component.scss
// module id = 917
// module chunks = 22